<template>
  <div>
    <v-tabs v-model="active" color="#FAFAFA" slider-color="primary" fixed-tabs>
      <v-tab active-class="tab" ripple>{{ $t("accountingPage.tabPending") }}</v-tab>
      <v-tab active-class="tab" ripple>{{ $t("accountingPage.tabDone") }}</v-tab>

      <v-tab-item>
        <CaptainPendingPayments v-if="active === 0" />
      </v-tab-item>

      <v-tab-item>
        <CaptainDonePayments v-if="active === 1" />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>

import CaptainDonePayments from "@/views/accounting/CaptainDonePayments";
import CaptainPendingPayments from "@/views/accounting/CaptainPendingPayments";

export default {
  name: "DriversAccounting",
  title() {
    return this.$t("accountingPage.driversAccountingTitle");
  },
  components: {
    CaptainPendingPayments,
    CaptainDonePayments
  },
  data() {
    return {
      active: 0,
    };
  },

};
</script>

<style scoped>
.tab {
  color: #e21024 !important;
}

.tab-content-wrapper {
  touch-action: pan-y !important;
  height: 100%;
  overflow-y: auto;
}
</style>
